import { Injectable } from "@angular/core";
import { Response } from "@angular/http";
import { Observable } from "rxjs/Observable";

import { CrudService } from "@atenea-cms";
import { EsportsTeam } from "./esports-team.model";

@Injectable()
export class EsportsTeamService extends CrudService {
  getRootUrl(): string {
    return "esports-teams";
  }

  save(esportsTeam: EsportsTeam) {
    return super.save(esportsTeam);
  }

  saveMultiple(esportsTeams: Array<EsportsTeam>) {
    return super.saveMultiple(esportsTeams);
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/esports-teams/shared/esports-team.service.ts